import { Show, type JSX } from "solid-js";
import { styles } from "../styles";

type ChipStyle = JSX.CSSProperties;

const BRAND_STYLES: Record<string, ChipStyle> = {
  "ポッピンハート": { background: "#ff9eff", color: "#eee" },
  "ミラクルムーン": { background: "#7fffff", color: "#222" },
  "フラワーマーチ": { background: "#ffff7f", color: "#222" },
  "クリスタルバース": { background: "#fff", color: "#222", border: "1px solid #222" },
  "スカーレットバタフライ": { background: "#e36868", color: "#eee" },
  "レインボーキャンディ": { background: "#bfff7f", color: "#222" },
  "プリティーコレクション": { background: "#ff7fbf", color: "#eee" },
  "ロゼッション": { background: "#7f7fff", color: "#eee" },
  "ベアベアベア": { background: "#ffbf7f", color: "#222" },
  "ラブマイミュージック": { background: "#bf7fff", color: "#ffff7f" },
  "プリズムストーン": { background: "#1a1917", color: "#e889af", border: "1px solid #d50d7a" },
  "プリンセスリング": { background: "linear-gradient(#ffff7f, #fff)", color: "#aa5eaa", border: "1px solid #666" },
  "キューティーカラット": { background: "linear-gradient(15deg, #b9f9ff 15%, #daaf08 85%, #b67b03 95%)", color: "#3020ff" },
  "フューチャースクール": { background: "linear-gradient(15deg, #ec6aa6 0%, #ae6aec 50%, #2772b9 95%)", color: "#ddd", border: "1px solid #03125f" },
  "ラブリーメロディー": { background: "#ff9eff", color: "#eee" },
  "ビビッドスター": { background: "#e36868", color: "#eee" },
  "レディアントアビス": { background: "#222", color: "#bbb" },
  "エターナルレヴュー": { background: "#bf7fff", color: "#ffff7f" },
  "エレクトロリミックス": { background: "#bfff7f", color: "#222" },
  "チェリーシュガー": { background: "#7fffff", color: "#222" },
  "シャイニングディーバ": { background: "#ffff7f", color: "#222" },
  "プリンセスマジック": { background: "#fff", color: "#222", border: "1px solid #222" },
};

export function BrandChip(props: { brand: string; onSelect?: (brand: string) => void; plain?: boolean }) {
  const style = () => BRAND_STYLES[props.brand] ?? { background: "#888", color: "#eee", border: "1px solid #555" };
  const className = () => props.plain ? styles.brandText : styles.brandChip;
  return (
    <Show
      when={props.onSelect}
      fallback={<span class={className()} style={props.plain ? undefined : style()}>{props.brand || "-"}</span>}
    >
      {(onSelect) => (
        <button
          class={className()}
          style={props.plain ? undefined : style()}
          type="button"
          title={`${props.brand}で絞り込む`}
          aria-label={`${props.brand}で絞り込む`}
          onClick={() => onSelect()(props.brand)}
        >{props.brand || "-"}</button>
      )}
    </Show>
  );
}
